// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"775b6f72","787":"bcae1211"}[chunkId] + ".chunk.js";
};